import {
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemButtonProps,
  ListItemProps,
  ListItemText,
} from '@mui/material';
import { AvatarBadge, AvatarIcon, Money, VaultIcon } from '../..';
import { UiVault } from '../../types';
import { MoneyGrow } from '../Typography/MoneyGrow';

export function VaultListItemContent({ vault }: { vault: UiVault }) {
  return (
    <>
      <ListItemAvatar>
        <AvatarBadge type="currency" currency={vault.balance.currency}>
          <AvatarIcon icon={<VaultIcon />} />
        </AvatarBadge>
      </ListItemAvatar>
      <ListItemText
        primary={<Money variant="body1" value={vault.balance} />}
        secondary={
          vault.totalRewards ? <MoneyGrow variant="caption" value={vault.totalRewards} /> : null
        }
      />
    </>
  );
}

export type VaultListItemProps = ListItemProps<'li', { vault: UiVault }>;

export function VaultListItem({ vault, ...props }: VaultListItemProps) {
  return (
    <ListItem {...props}>
      <VaultListItemContent vault={vault} />
    </ListItem>
  );
}

export type VaultListItemButtonProps<RootComponent extends React.ElementType = 'div'> =
  ListItemButtonProps<RootComponent, { vault: UiVault }>;

export function VaultListItemButton<RootComponent extends React.ElementType = 'div'>({
  vault,
  ...props
}: VaultListItemButtonProps<RootComponent>) {
  return (
    <ListItemButton {...props}>
      <VaultListItemContent vault={vault} />
    </ListItemButton>
  );
}
